import { useDispatch } from "react-redux";

import { userActions } from "store";

const RedirectToLogout = () => {
	const dispatch = useDispatch();

	dispatch(userActions.logout());
	return null;
};

export default RedirectToLogout;
